import Vue from "vue";
import Component from "vue-class-component";
import SidebarComponent from "@/components/sidebar/sidebar.component.vue";
import HeaderComponent from "@/components/header/header.component.vue";
import LoaderComponent from "@/components/loader/loader.component.vue";
import ModalPermissionsComponent from "@/components/modal-permissions/modal-permissions.component.vue";
import ModalLoginComponent from "@/components/modal-login/modal-login.component.vue";
// External components
import Datepicker from "vuejs-datepicker";
// Services
import CompanyService from "@/core/services/company.service";
import SidebarService from "@/core/services/sidebar.service";

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    LoaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    Datepicker,
  },
})
export default class CompanyComponent extends Vue {
  companyService: any = new CompanyService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  searchFlag: boolean = false;
  modal: boolean = false;
  deleteIcon: boolean = false;
  nextPositionDisabled: boolean = false;
  previousPositionDisabled: boolean = true;
  pagination: boolean = true;
  companyToDelete: any;
  searchFlag: any = [];
  companyList: any = [];
  filterCompanyList: any = [];
  search: any = "";
  searchByDate: any = "";
  createdAt: string = "";
  filterConcatDate: string = "";
  pageOffset: number = 0;
  itemsPerPage: number = 50;
  totalPages: number;
  currentPage: number = 1;
  nextPage: number = 2;
  totalOfCompany: number = 0;
  itemsOfFrom: number = 0;
  itemsOfTo: number = 0;

  mounted() {
    const _ = this;
    _.get(_.pageOffset, _.itemsPerPage);
    _.filterDate();
  }

  filterByDate() {
    const _ = this;
    _.deleteIcon = true;
    let day =
      _.searchByDate.getDate() < 10
        ? "0" + _.searchByDate.getDate()
        : _.searchByDate.getDate();
    let month =
      _.searchByDate.getMonth() < 10
        ? "0" + (_.searchByDate.getMonth() + 1)
        : _.searchByDate.getMonth() + 1;
    let year = _.searchByDate.getFullYear();
    _.filterConcatDate = `${year}-${month}-${day}`;
    _.filterCompanyList = _.companyList.filter((role) => {
      let parseDate: any = role.createdAt.split("T");
      parseDate = parseDate[0];
      return _.filterConcatDate == parseDate;
    });
  }

  deleteDate() {
    const _ = this;
    _.filterConcatDate = "";
    _.deleteIcon = false;
    if (_.filterConcatDate == "") {
      _.searchByDate = "";
      _.filterCompanyList = _.companyList;
      return;
    }
  }

  filterDate(date: any = "") {
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  closeSidebar() {
    const _ = this;
    _.sidebarService.close();
  }

  openModal(id) {
    const _ = this;
    _.companyToDelete = id;
    _.modal = true;
  }

  get(pageOffset = 0, itemsPerPage = 50) {
    const _ = this;
    console.log(pageOffset, itemsPerPage);
    _.isLoading = true;
    _.companyService
      .get(pageOffset, itemsPerPage)
      .then((data: any) => {
        _.companyList = data["data"].companies;
        _.filterCompanyList = data["data"].companies;
        _.filterCompanyList.sort(function(a, b) {
          var textA = a.name.toLowerCase();
          var textB = b.name.toLowerCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        _.totalOfCompany = data["data"].total;
        _.totalPages = Math.ceil(_.totalOfCompany / itemsPerPage);
        if (_.totalPages <= 1) {
          _.pagination = false;
        }
        if (pageOffset == 0) {
          _.itemsOfFrom = 1;
          _.itemsOfTo = _.companyList.length;
          _.previousPositionDisabled = true;
        }
        if (pageOffset == _.totalPages - 1) {
          _.itemsOfTo = _.totalOfCompany;
        }
        if (pageOffset != 0) {
          _.previousPositionDisabled = false;
        }
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        if (err.response.data.message.includes("Invalid or inexistent user")) {
          localStorage.removeItem("tk_auth");
          _.logInModal = true;
        }
        _.isLoading = false;
      });
  }

  delete_company() {
    const _ = this;
    _.isLoading = true;
    _.companyService
      .delete_company(_.companyToDelete)
      .then((data: any) => {
        _.get();
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        _.isLoading = false;
      });
  }

  nextPageAction() {
    const _ = this;
    _.itemsOfTo = _.itemsOfTo + _.companyList.length;
    console.log(_.itemsOfTo, "incremento 1");
    _.itemsOfFrom = _.itemsOfFrom + _.companyList.length;
    console.log(_.itemsOfFrom, "incremento 2");

    _.pageOffset++;
    _.currentPage++;
    _.nextPage++;
    _.get(_.pageOffset);

    if (_.totalPages == _.currentPage) {
      _.nextPositionDisabled = true;
      console.log(_.nextPositionDisabled, "98898");
      return;
    }
  }

  previousPageAction() {
    const _ = this;
    if (_.currentPage == 1) {
      return;
    }

    _.itemsOfTo = _.itemsOfTo - _.companyList.length;
    _.itemsOfFrom = _.itemsOfFrom - _.companyList.length;
    _.pageOffset--;
    _.currentPage--;
    _.nextPage--;
    _.get(_.pageOffset);

    if (_.totalPages != _.currentPage) {
      _.nextPositionDisabled = false;
      console.log(_.nextPositionDisabled, "false");
      return;
    }
  }
}
